import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles((theme) => ({
    logsDivButton: {
        display: "flex",
        justifyContent: "flex-end",
        marginTop: "30px",
        marginBottom: "25px"
    },
    logsButton: {
        display: "flex",
        flexDirection: "row",
        justifyContent: "center",
        alignItems: "center",
        padding: "10px 15px",
        background: "linear-gradient(90deg, #824ED2 -0.14%, #B07DFF 99.93%)",
        border: "none",
        borderRadius: "4px",
        fontStyle: "normal",
        fontWeight: 600,
        fontSize: "16px",
        textAlign: "center",

        /* Background/White Color */

        color: "#FFFFFF",
        lineHeight: "22px"
    },
    logDiv: {
        minHeight: "726px",
       
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
        padding: "40px",
        background: "#FFFFFF",
        borderRadius: "12px",
        [theme.breakpoints.down('sm')]: {
            width:"100%",
            wordBreak:"break-all"
        },
    },
    logDivTxt: {
        fontStyle: "normal",
        fontFamily: 'Roboto',
        fontWeight: 600,
        fontSize: "16px",
        lineHeight: "22px",
        color: "#5B6773",
        marginBottom: "30px"
    },
    logDivTxt1: {
        fontStyle: "normal",
        fontFamily: 'Roboto',
        fontWeight: 600,
        fontSize: "16px",
        lineHeight: "22px",
        color: "#5B6773",
      
    }
}))